import {
	get,
	set,
	del,
	createStore,
	type UseStore,
	clear,
	keys,
} from "idb-keyval";
import type { KeyValueStorage } from "./KeyValueStorage";

export class BrowserCacheStorage implements KeyValueStorage {
	private db: UseStore;
	constructor(dbName: string, store: string) {
		this.db = createStore(dbName, store);
	}

	async getItem(key: string): Promise<string | null> {
		const value = await get(key, this.db);
		return value ?? null;
	}

	async getLastModified(key: string): Promise<string | null> {
		const value = await get(`${key}-last-modified`, this.db);
		return value ? new Date(value).toISOString() : null;
	}

	async setItem(key: string, value: string): Promise<void> {
		await set(key, value, this.db);
		await set(`${key}-last-modified`, new Date().toISOString(), this.db);
	}

	async removeItem(key: string): Promise<void> {
		await del(key, this.db);
		await del(`${key}-last-modified`, this.db);
	}

	async clear(): Promise<void> {
		await clear(this.db);
	}

	async keys(): Promise<string[]> {
		return (await keys(this.db))
			.map((key) => key.toString())
			.filter((key) => !key.endsWith("-last-modified"));
	}

	isAvailable(): boolean {
		return typeof indexedDB !== "undefined";
	}
}
